module.exports = __webpack_public_path__ + "images/if6_schnellrechner_scenario_1_web.svg?92737c02de47eb6da705edfdf3c1abac";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/if6_schnellrechner_scenario_1_web.svg
// module id = aR7C
// module chunks = 0